<template>
  <div>
    <v-container class="page__wrapper pa-4" style="min-height: 50vh">
      <template>
        <v-card
          elevation="0"
          rounded
          :style="
            IsCheckManagePage
              ? 'border: 0px !important; magin-top: 0px !important; box-shadow: none !important; padding: 0px !important'
              : 'padding: 0px 20px 0px 20px'
          "
        >
          <v-card-title style="gap: 10px">
            <h4
              v-if="!IsCheckManagePage"
              style="color: var(--primary-color); font-size: 1.5em"
            >
              ZWIZ.AI {{ $t('Rich menu') }}
            </h4>
            <h2 v-else style="font-size: 110%">
              {{ $t('Select your channel ID') }}
            </h2>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              outlined
              rounded
              dense
              hide-details
              :append-icon="'mdi-magnify'"
              color="primary"
              class="mr-2"
              style="max-width: 200px"
            ></v-text-field>
            <v-dialog v-model="dialog" persistent max-width="600px">
              <template #activator="{ on, attrs }">
                <v-btn
                  color="primary btn-custom"
                  depressed
                  class="mr-3"
                  v-bind="attrs"
                  @click="
                    isEdit = false
                    dataConnect.channel_id = ''
                    dataConnect.channel_secret = ''
                  "
                  v-on="on"
                  :disabled="!getPermission('shop_services')"
                >
                  <v-icon class="mr-2">mdi-plus</v-icon>
                  <span>{{ $t('Add Line OA channel') }}</span>
                </v-btn>
              </template>
              <v-card>
                <div class="pa-3">
                  <validation-observer
                    ref="addChannelForm"
                    v-slot="{ invalid }"
                  >
                    <form @submit.prevent="addChannel">
                      <v-card-title style="border-bottom: 0px solid">
                        <h3>{{ $t('Channel information') }}</h3>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="btn-custom primary"
                          depressed
                          class="right"
                          @click="howto()"
                          ><span style="font-size: 11px">
                            {{ $t('How to connect') }} ?</span
                          >
                        </v-btn>
                      </v-card-title>
                      <v-card-text>
                        <span class="mt-3"
                          >Channel ID <span class="color-red">*</span></span
                        >
                        <validation-provider
                          v-slot="{ errors }"
                          name="Channel ID"
                          rules="required"
                        >
                          <v-text-field
                            v-model="dataConnect.channel_id"
                            dense
                            outlined
                            :disabled="isEdit"
                            :error-messages="errors"
                          ></v-text-field>
                        </validation-provider>
                        <span class="mt-3"
                          >Channel secret <span class="color-red">*</span></span
                        >
                        <validation-provider
                          v-slot="{ errors }"
                          name="Channel secret"
                          rules="required"
                        >
                          <v-text-field
                            v-model="dataConnect.channel_secret"
                            dense
                            outlined
                            :error-messages="errors"
                          ></v-text-field>
                        </validation-provider>
                      </v-card-text>
                      <v-card-actions
                        class="pb-6"
                        style="justify-content: center"
                      >
                        <v-btn
                          class="black--text"
                          color="grey lighten-2"
                          min-width="200px"
                          depressed
                          @click="dialog = false"
                          >{{ $t('Cancel') }}</v-btn
                        >
                        <v-btn
                          color="primary"
                          min-width="200px"
                          depressed
                          :disabled="invalid"
                          type="submit"
                          ><span>{{ $t('Submit') }}</span>
                        </v-btn>
                      </v-card-actions>
                    </form>
                  </validation-observer>
                </div>
              </v-card>
            </v-dialog>
            <v-btn
              v-if="!IsCheckManagePage"
              outlined
              color="primary"
              class="btn-custom"
            >
              <span @click="gotoRichMenu">{{ $t('Go to app') }}</span>
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-list-item
              v-for="(channel, i) in filterChannels"
              :key="i"
              class="pa-0 pr-2 pl-2"
            >
              <span class="mr-5">Line OA</span>
              <v-list-item-content>
                <v-list-item-title>{{
                  channel.channel_name
                }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  channel.channel_id
                }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action style="display: block">
                <v-btn
                  v-if="IsCheckManagePage"
                  outlined
                  class="btn-custom green mr-3 small-btn light-weight"
                  style="box-shadow: none"
                  @click="selectCard(channel)"
                  :disabled="!getPermission('shop_services')"
                  >{{ $t('Select') }}</v-btn
                >
                <v-btn
                  class="mr-3"
                  style="box-shadow: none"
                  color="primary"
                  fab
                  x-small
                  dark
                  @click="clickEditChannel(channel)"
                  :disabled="!getPermission('shop_services')"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                  style="box-shadow: none"
                  color="primary"
                  fab
                  x-small
                  outlined
                  dark
                  @click="deleteChannel(channel)"
                  :disabled="!getPermission('shop_services')"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>

            <template
              v-if="
                (!search || (search && search.trim() == '')) &&
                channels.length > 3
              "
            >
              <v-divider />
              <div class="text-center">
                <v-btn text block @click="showLineMore = !showLineMore">
                  {{ showLineMore ? 'Show less' : 'Show more' }}</v-btn
                >
              </div>
            </template>
          </v-card-text>
        </v-card>
      </template>
    </v-container>
  </div>
</template>

<script>
import LINE_logo from '../assets/image/logo/LINE_logo.png'
import Facebook_logo from '../assets/image/logo/Facebook_logo.png'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      LINE_logo: LINE_logo,
      Facebook_logo: Facebook_logo,
      channels: [],
      dialog: false,
      dataConnect: {
        app: 'line',
        channel_id: '',
        channel_secret: ''
      },
      showLineMore: false,
      search: '',
      isEdit: false
    }
  },
  computed: {
    ...mapGetters({
      channelToken: 'channelIdManager/getChannelToken',
      IsCheckManagePage: 'channelIdManager/getCheckManagePage',
      permissionRole: 'ssoAccount/getPermissionRoleStore'
    }),
    filterChannels() {
      var channels = this._.cloneDeep(this.channels)

      if (this.search && this.search.trim()) {
        return channels.filter((el) => {
          return el.channel_name
            .toLowerCase()
            .includes(this.search.trim().toLowerCase())
        })
      } else {
        if (!this.showLineMore) {
          channels = channels.splice(0, 3)
        }
        return channels
      }
    }
  },
  async mounted() {
    await this.getChannel()
  },
  methods: {
    clickEditChannel(channel) {
      this.dataConnect.id = channel.id
      this.dataConnect.channel_id = channel.channel_id
      this.dataConnect.channel_secret = channel.channel_secret
      this.dialog = true
      this.isEdit = true
    },
    selectCard(channel) {
      this.$emit('ActiveCreditCard')
      this.$store.dispatch('channelIdManager/selectChannel', channel)
    },
    async getChannel() {
      this.$store.dispatch('setOverlay', true)
      var res = await this.$store.dispatch(
        'channelIdManager/getChannelByAccount'
      )
      if (res) {
        this.$store.dispatch('setOverlay', false)
        this.channels = res.data.data
      } else {
        this.$store.dispatch('setOverlay', false)
        this.$notify({
          group: 'foo',
          type: 'error',
          title: 'Error',
          text: `Something went wrong.`
        })
      }
    },
    gotoRichMenu() {
      const path = `/${this.currentLang}/richmenu`
      if (this.$route.path !== path) {
        this.$router.push({ path })
      }
    },
    async addChannel() {
      this.dialog = false
      this.$store.dispatch('setOverlay', true)
      if (this.isEdit) {
        let res = await this.$store.dispatch(
          'channelIdManager/putCreateChannel',
          { platform_channel_id: this.dataConnect.id, data: this.dataConnect }
        )
        if (res) {
          this.$store.dispatch('setOverlay', false)
          this.dataConnect = {
            app: 'line',
            channel_id: '',
            channel_secret: ''
          }
          this.getChannel().then(() => {
            this.channels.map((item) => {
              if (item.id === res.data.platform_channel_id) {
                this.selectCard(item)
                this.$notify({
                  group: 'foo',
                  type: 'success',
                  title: 'Success',
                  text: 'Your channel has been updated. '
                })
              }
            })
          })
          this.$nextTick(() => this.$refs.addChannelForm.reset())
        } else {
          this.dialog = true
          this.$store.dispatch('setOverlay', false)
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Error',
            text: `Your channel has been not created.`
          })
        }
      } else {
        let checkDupChannel = this.filterChannels.find(
          (item) => item.channel_id === this.dataConnect.channel_id
        )
        if (checkDupChannel) {
          this.$alert('Line OA channel ของคุณมีอยู่แล้ว', 'Error', 'error')
        } else {
          let res = await this.$store.dispatch(
            'channelIdManager/postCreateChannel',
            this.dataConnect
          )
          if (res) {
            var prefix = window.location.hostname == 'app.zwiz.ai' ? 'z_' : ''
            this.$gtag.event('event', {
              event_category: prefix + 'Add line OA channel'
              // event_label: bot.pagename + utm,
            })
            this.$store.dispatch('setOverlay', false)
            this.dataConnect = {
              app: 'line',
              channel_id: '',
              channel_secret: ''
            }
            this.getChannel().then(() => {
              this.channels.map((item) => {
                if (item.id === res.data.platform_channel_id) {
                  // console.log(item);
                  this.selectCard(item)
                  this.$notify({
                    group: 'foo',
                    type: 'success',
                    title: 'Success',
                    text: 'Your channel has been created. '
                  })
                }
              })
            })
            this.$nextTick(() => this.$refs.addChannelForm.reset())
          } else {
            this.dialog = true
            this.$store.dispatch('setOverlay', false)
            this.$notify({
              group: 'foo',
              type: 'error',
              title: 'Error',
              text: `Your channel has been not created.`
            })
          }
        }
      }
    },

    howto() {
      window.open('https://blog.zwiz.app/connectrichmenu/', '_blank')
    },

    async deleteChannel(channel) {
      this.$confirm(
        `${this.$t('you want to delete')} ${channel.channel_name} ?`,
        this.$t('Are you sure?'),
        'question',
        {
          reverseButtons: true,
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel')
        }
      )
        .then(async () => {
          this.$store.dispatch('setOverlay', true)
          var res = await this.$store.dispatch(
            'channelIdManager/deleteChannel',
            {
              platform_channel_id: channel.id
            }
          )
          if (res.status == 200) {
            if (typeof res.data !== 'undefined') {
              this.$store.dispatch('setOverlay', false)
              this.getChannel()
              this.channels.filter((item) => item.id !== channel.id)
              this.$notify({
                group: 'foo',
                type: 'success',
                title: 'Success',
                text: `Your ${channel.channel_name} has been deleted.`
              })
            } else {
              // console.log(res.response);
              this.$store.dispatch('setOverlay', false)
              this.$notify({
                group: 'foo',
                type: 'error',
                title: 'Error',
                text: `${res.response.data.reason}. This Line OA connected with ${res.response.data.line_richmenu[0].name} `
              })
            }
          } else {
            this.$store.dispatch('setOverlay', false)
            this.$notify({
              group: 'foo',
              type: 'error',
              title: 'Error',
              text: `Your ${channel.channel_name} has been not deleted.`
            })
          }
        })
        .catch(() => {
          // console.log("cancel");
        })
    },

    getPermission(permissionName) {
      if (!this.permissionRole) return false
      const isAllow = this.permissionRole.permission[permissionName].rule_write
      return isAllow
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card .v-card__title {
  border-bottom: 0.5px solid;
  //   border-color: #ff294879;
}
.social-icon {
  border-radius: 11px 11px 0px 11px;
  border: none;
  width: 120px;
  height: 36px;
  padding: 2px 8px;
}
</style>
